module.exports = __webpack_public_path__ + "img/m-service-banner-normal.0a8dcfa8.webp";